import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StyledHighlightInfo = styled.div`
  background-color: ${(props) => `${props.theme.colors.pale}`};
  padding: 14px 22px;
  border-radius: 8px;
  font-style: ${(props) => (props.theme.standardLayout.shouldTextsBeItalic.yourOptimisation ? 'italic' : 'normal')};

  p:last-child {
    margin-bottom: 0;
  }
`;

export const ChartWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ChartTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const ExpandButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  flex-shrink: 0;
  margin-top: -2px;

  &:hover {
    opacity: 0.7;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const AccordionSpacer = styled.div``;
